import { AI_FIELDS } from "./aiReview";

const same = (a, b) => a === b || JSON.stringify(a) === JSON.stringify(b);

function rowsLabel(a, b, columns, t) {
    if (b.length > a.length) return b.length - a.length === 1 ? t("h_row_add") : t("h_rows_add", { n: b.length - a.length });
    if (b.length < a.length) return a.length - b.length === 1 ? t("h_row_del") : t("h_rows_del", { n: a.length - b.length });
    const byId = new Map(a.map((r) => [r.id, r]));
    if (a.some((r, i) => r.id !== b[i]?.id) && b.every((r) => byId.has(r.id))) return t("h_rows_order");
    const cells = [];
    b.forEach((r) => {
        const o = byId.get(r.id);
        if (!o) return;
        Object.keys({ ...o, ...r }).forEach((k) => { if (!["edits", "ai_orig", "position"].includes(k) && !same(o[k], r[k])) cells.push(k); });
    });
    if (!cells.length) return t("h_table");
    const keys = [...new Set(cells)];
    if (cells.length === 1 || (keys.length === 1 && cells.length === 1)) {
        const col = columns.find((c) => c.key === keys[0] || c.calc === keys[0]);
        return t("h_cell", { col: col?.label || keys[0] });
    }
    if (keys.includes("blindPos") && keys.length === 1) return t("h_renumber");
    return t("h_cells", { n: cells.length });
}

function offsetsLabel(a, b, t) {
    const ka = Object.keys(a || {}), kb = Object.keys(b || {});
    if (kb.length > ka.length) return t("h_bubble_place");
    if (kb.length < ka.length) return t("h_bubble_tray");
    return t("h_bubble_move");
}

function aiLabel(a, b, t) {
    if (!(a || []).length && (b || []).length > 1) return t("h_ai_analysis");
    if ((a || []).length > 1 && !(b || []).length) return t("h_ai_analysis");
    if ((b || []).length === (a || []).length + 1) {
        const ids = new Set((a || []).map((x) => x._id));
        const n = b.find((x) => !ids.has(x._id));
        if (n?.f.name?.value && !n.f.name.box) return t("h_ai_insert", { name: n.f.name.value });
    }
    if ((b || []).length > (a || []).length) return t("h_ai_add");
    if ((a || []).length === (b || []).length && a.some((x, i) => x._id !== b[i]._id) && b.every((x) => (a || []).some((y) => y._id === x._id))) return t("h_ai_move");
    if ((b || []).length < (a || []).length) return t("h_ai_join");
    const byId = new Map((a || []).map((x) => [x._id, x]));
    for (const it of b || []) {
        const o = byId.get(it._id);
        if (!o) return t("h_ai_split");
        if (o.group !== it.group) return t("h_ai_join");
        if (o.include !== it.include) return t("h_ai_edit");
        for (const { key } of AI_FIELDS) {
            const fa = o.f[key], fb = it.f[key];
            if (same(fa, fb)) continue;
            const f = t(`ai_f_${key}`);
            if (fb?.fb === "removed" && fa?.fb !== "removed") return t("h_ai_remove", { f });
            if (fb?.fb === "ok" && fa?.fb !== "ok") return t("h_ai_confirm", { f });
            if (fb?.manual && !fa?.manual) return t("h_ai_assign", { f });
            return t("h_ai_field", { f });
        }
    }
    return t("h_ai_edit");
}

// Human label for a project-state change ("Pakeisti Plotis", "Perkelti burbuliuką", ...).
export function describeChange(a, b, t) {
    if (a.rows !== b.rows && !same(a.rows, b.rows)) return rowsLabel(a.rows, b.rows, b.columns || [], t);
    if (a.ai !== b.ai && !same(a.ai, b.ai)) return aiLabel(a.ai, b.ai, t);
    if (!same(a.unitOffsets, b.unitOffsets)) return offsetsLabel(a.unitOffsets, b.unitOffsets, t);
    if (!same(a.bubbleStyles, b.bubbleStyles)) return t("h_bubble_style");
    if (!same(a.pageNames, b.pageNames)) return t("h_page_name");
    if (!same(a.columns, b.columns)) return t("h_columns");
    return t("h_bubbles");
}
